@if (cart()) {
  @if (items().length) {
    <div class="cart-content">
      <div class="left">
        <ui-page-header [boxed]="false">
          Warenkorb
          <ui-delivery-windows-dialog custom-action [refDate]="deliveryWindowsRefDate()"></ui-delivery-windows-dialog>
        </ui-page-header>
        @if (esaInfo().isInvalidEsaCount) {
          <ui-alert
            [message]="'Ihre Bestellung enthält ' + esaInfo().esaCount + ' Premium Spirituosen/Wein Flasche(n). Sie benötigen noch ' + esaInfo().missingEsaItems + ' weitere Flasche(n) um bestellen zu können.'"
            theme="info"
          ></ui-alert>
        }

        <div class="grouped-item-list">
          @if (nodes().length > 1) {
            <ui-product-categories-filter [(selectedNodes)]="selectedNodes" [nodes]="nodes()"></ui-product-categories-filter>
          }

          @if (nodes().length === 1) {
            @let node = nodes()[0];
            <mat-chip-option class="single-node-chip" [selected]="true" [selectable]="false">{{ node.label }}</mat-chip-option>
            <ui-order-item-category-list
              [category]="node"
              (itemQuantityChanged)="onItemQuantityChanged($event)"
              (itemRemoved)="onItemRemoved($event)">
            </ui-order-item-category-list>
          } @else {
            @for (topLevelCategory of visibleNodes(); track topLevelCategory.id) {
              <ui-expander
                [expanded]="expandedMap.get(topLevelCategory.label) ?? true"
                (expandedChange)="categoryExpandedChanged($event,topLevelCategory)"
                [title]="topLevelCategory.label"
              >
                <ui-order-item-category-list
                  [category]="topLevelCategory"
                  (itemQuantityChanged)="onItemQuantityChanged($event)"
                  (itemRemoved)="onItemRemoved($event)">
                </ui-order-item-category-list>
              </ui-expander>
            }
          }
        </div>
      </div>
      @if (orderBottomBarVisible()) {
        <ui-order-bottom-bar (mainClicked)="goToCheckout()" sideSheetLabel="Warenkorb" mainButtonLabel="zur Kasse" [isLoading]="isCartQueueLoading()" [disabled]="esaInfo().isInvalidEsaCount" [mainButtonIsSplit]="true" splitButtonIcon="circle-info" (secondaryClicked)="openProductAvailabilityInfo()">
          <ng-container sideSheetContent>
            <div class="cart-side-sheet-content">
              @let summary = calculationSummary();
              @if (summary && !summary.redacted) {
                <ui-order-overview-details [minimumOrderValue]="cart()?.minimumOrderValue" [data]="summary"></ui-order-overview-details>
              }

              @if (orderVouchersEnabled() && cart()?.vouchers) {
                <ui-order-vouchers [data]="voucherItems()"></ui-order-vouchers>
              }
            </div>
          </ng-container>

          <ng-container sideSheetActions>
            <ng-container *ngTemplateOutlet="checkoutButton"></ng-container>
            <ui-button buttonStyle="text" (clicked)="deleteAllItemsInCart()">Warenkorb leeren</ui-button>
          </ng-container>
        </ui-order-bottom-bar>
      } @else {
        <div #calculationSummaryElement class="right">
          @let summary = calculationSummary();
          <div class="scroll-area">
            @if (!isMobile()) {
              <ui-cross-selling-slider headline="Häufig zusammen gekauft" [small]="true"></ui-cross-selling-slider>
            }

            @if (summary) {
              <ui-order-overview [minimumOrderValue]="cart()?.minimumOrderValue" [data]="summary"></ui-order-overview>
            }

            @if (orderVouchersEnabled() && cart()?.vouchers) {
              <mat-card class="voucher-card">
                <mat-card-header (click)="toggleShowVoucherInput()">
                  <mat-card-title>Gutscheine <span>(optional)</span></mat-card-title>
                  <ui-icon [faName]="showVoucherInput()? 'chevron-up' : 'chevron-down'" faStyle="solid"></ui-icon>
                </mat-card-header>
                <ui-expander-content [expanded]="showVoucherInput()">
                  <div class="wrapper-vouchers">
                    <ui-order-vouchers [data]="voucherItems()"></ui-order-vouchers>
                  </div>
                </ui-expander-content>
              </mat-card>
            }
          </div>
          <div class="actions">
            <ng-container *ngTemplateOutlet="checkoutButton"></ng-container>

            <ui-button [disabled]="isCartQueueLoading()" (clicked)="deleteAllItemsInCart()" [small]="true" buttonStyle="text">Alle Artikel löschen</ui-button>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="no-products-container">
      <div>
        <ui-icon faName="cart-shopping" faStyle="light"></ui-icon>
      </div>
      <h1>Der Warenkorb ist leer</h1>
      <p>Es befinden sich keine Artikel im Warenkorb</p>
    </div>
  }
}

<ng-template #checkoutButton>
  <ui-split-button
    (primaryClicked)="goToCheckout()"
    (secondaryClicked)="openProductAvailabilityInfo()"
    [disabled]="esaInfo().isInvalidEsaCount || isCartQueueLoading()"
    [loading]="isCartQueueLoading()"
    icon="circle-info"
    iconStyle="light"
    buttonStyle="filled"
    type="button"
  >
    Zur Kasse
  </ui-split-button>
</ng-template>
